import { Blockquote } from '@tiptap/extension-blockquote';
import { BulletList } from '@tiptap/extension-bullet-list';
import { Color } from '@tiptap/extension-color';
import Heading from '@tiptap/extension-heading';
import Link from '@tiptap/extension-link';
import ListItem from '@tiptap/extension-list-item';
import { OrderedList } from '@tiptap/extension-ordered-list';
import Placeholder from '@tiptap/extension-placeholder';
import { Strike } from '@tiptap/extension-strike';
import TextAlign from '@tiptap/extension-text-align';
import TextStyle, { TextStyleOptions } from '@tiptap/extension-text-style';
import StarterKit from '@tiptap/starter-kit';

enum KEYBOARD_SHORTCUTS {
  CmdShiftS = `Cmd-Shift-s`, // strikethrough
  CmdAlt1 = `Cmd-Alt-1`, // override h1 to nothing (ctrl alt 1 / mod alt 1)
  CmdAlt2 = `Cmd-Alt-2`, // title (ctrl alt 2 / mod alt 2)
  CmdAlt3 = `Cmd-Alt-3`, // subtitle (ctrl alt 3 / mod alt 3)
  CmdAlt4 = `Cmd-Alt-4`, // numbered list (ctrl alt 4 / mod alt 4)
  CmdAlt5 = `Cmd-Alt-5`, // bulleted list (ctrl alt 5 / mod alt 5)
  CmdAlt6 = `Cmd-Alt-6`, // block quote   (ctrl alt 6 / mod alt 6)
}

const CustomHeading = Heading.extend({
  addKeyboardShortcuts() {
    return {
      [KEYBOARD_SHORTCUTS.CmdAlt1]: () => false,
      [KEYBOARD_SHORTCUTS.CmdAlt2]: () =>
        this.editor.chain().focus().toggleHeading({ level: 4 }).run(),
      [KEYBOARD_SHORTCUTS.CmdAlt3]: () =>
        this.editor.chain().focus().toggleHeading({ level: 5 }).run(),
    };
  },
});

const CustomNumberedList = OrderedList.extend({
  addKeyboardShortcuts() {
    return {
      [KEYBOARD_SHORTCUTS.CmdAlt4]: () =>
        this.editor.chain().focus().toggleOrderedList().run(),
    };
  },
});

const CustomBulletList = BulletList.extend({
  addKeyboardShortcuts() {
    return {
      [KEYBOARD_SHORTCUTS.CmdAlt5]: () =>
        this.editor.chain().focus().toggleBulletList().run(),
    };
  },
});

const CustomBlockQuote = Blockquote.extend({
  addKeyboardShortcuts() {
    return {
      [KEYBOARD_SHORTCUTS.CmdAlt6]: () =>
        this.editor.chain().focus().toggleBlockquote().run(),
    };
  },
});

const CustomStrike = Strike.extend({
  addKeyboardShortcuts() {
    return {
      [KEYBOARD_SHORTCUTS.CmdShiftS]: () =>
        this.editor.chain().focus().toggleStrike().run(),
    };
  },
});

export const richTextEditorExtensions = [
  StarterKit.configure({
    blockquote: false,
    bulletList: false,
    heading: false,
    horizontalRule: false,
    orderedList: false,
    strike: false,
    code: false,
    // ignore for drag and drop
    dropcursor: false,
  }),
  Color.configure({ types: [TextStyle.name, ListItem.name] }),
  TextStyle.configure({ types: [ListItem.name] } as Partial<TextStyleOptions>),
  Placeholder.configure({
    placeholder: 'Write something…',
  }),
  Link.configure({
    autolink: true,
  }),
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
  CustomBulletList,
  CustomHeading.configure({
    levels: [4, 5],
  }),
  CustomNumberedList,
  CustomBlockQuote,
  CustomStrike,
];
